// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36UPl","wrapper-nopadding":"wrapper-nopadding__3C_G0","loading":"loading__3UO_m","error":"error__3dkfR","table-loading":"table-loading__2U9Ij","empty-val":"empty-val__3_f9L","panelheader-tools":"panelheader-tools__D1s9O","propsPanels":"propsPanels__1nsvn","new":"new__2ZUR7","marginLm":"marginLm__OlQoa","marginRm":"marginRm__qVQwJ","fullWidth":"fullWidth__tIwr0","fullHeight":"fullHeight__3kmoI","noData":"noData__1LEu8","container":"container__HYtFX","switcher":"switcher__2IW2J"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/ADRView/DynamicChart/styles.scss
// module id = 2228
// module chunks = 1